import { render } from "./Survey.vue?vue&type=template&id=3571ed7a&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=3571ed7a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3571ed7a"

export default script